module.exports = __webpack_public_path__ + "img/index-live.8fab5f53.png";